import * as React from 'react'

const LogoNBC: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    id='Camada_1'
    width='100%'
    height='100%'
    viewBox='0 0 924 303'
    {...props}
  >
    <style>{'.st0{fill:#21428a}'}</style>
    <path
      d='M854.1 110.2c-15.3-33.3-48.9-56.5-88-56.5s-72.7 23.2-88 56.5h176zM678.1 190.8c15.3 33.3 48.9 56.5 88 56.5s72.7-23.2 88-56.5h-176zM672.3 126.3c-1.3 5.2-2.2 10.7-2.7 16.2h192.9c-.5-5.6-1.4-11-2.7-16.2H672.3zM859.8 174.7c1.4-5.2 2.2-10.7 2.7-16.2H669.6c.5 5.5 1.4 11 2.7 16.2h187.5z'
      className='st0'
    />
    <path
      d='m692.1 212.5 74-158.8 74.1 158.8z'
      style={{
        fill: '#cad51b',
      }}
    />
    <path
      d='M226.5 167c0 25.1-17.3 42.1-40.8 42.1-13.4 0-26-3.5-36.8-7.2V95.1h20.9v40.2c6.2-6.5 13.7-10.1 21.8-10.1 20.8 0 34.9 17.1 34.9 41.8zm-20 .1c0-14-7.5-24.4-20.8-24.4-6 0-11.3 3-15.9 7.8V189c5.1 1.7 9.2 2.9 14.7 2.9 13.3.1 22-10.5 22-24.8zM295 187.9l3.6 15.5c-6.2 3.5-13.2 5.6-20.9 5.6-23.3 0-42.3-18.5-42.3-41.4 0-23 19-41.5 42.3-41.5 7.7 0 14.7 2.1 20.9 5.6l-3.6 15.6c-8.7-4.5-17.3-4.1-17.3-4.1-12.6 0-22.9 11-22.9 24.4s10.2 24.2 22.9 24.2c0 0 8.5.5 17.3-3.9zM384.5 167c0 25.3-17.3 42-39.7 42-11.4 0-22.3-3-33.2-6.5V95.1h13.2v42.6c7.1-7.7 15.8-12.3 24.7-12.3 21-.1 35 17.1 35 41.6zm-12.7.1c0-17.7-9.8-30.4-25.7-30.4-8 0-15.3 4.8-21.4 12v45.1c7.4 2.3 12.6 3.9 19.3 3.9 15.9.1 27.8-12.5 27.8-30.6zM458.5 157.1l-.2 49.2H447l-1.8-9.9c-6.8 7.4-15.5 12-25.7 12-15.3 0-25.4-9.5-25.4-22.9 0-14.6 9.3-23 26.3-23 6.8 0 17.7 1.7 24.7 4.1v-9.2c0-10.8-10.1-19.6-23.3-19.6-7.8 0-13.4 1.4-19.6 4.5l-2.4-10.1c7.7-4.2 14.6-5.9 23.9-5.9 17 .1 34.8 11.5 34.8 30.8zm-13.4 19.8c-7.5-2.7-14.1-4.5-22.4-4.5-12.9 0-15.8 6.3-15.8 12 0 8.6 5.6 13.1 15.8 13.1 6.9 0 16.8-4.8 22.4-12.5v-8.1zM541.3 161.1v45.4h-13.2v-45.4c0-15.3-7.2-22.9-20.5-22.9-8.1 0-15.2 4.4-20.9 12.6l.2 55.7h-13.4v-78.2h11.6l1.7 10.4c6.9-7.5 15.3-11.9 24.8-11.9 18 0 29.7 9.5 29.7 34.3zM624.7 206.3H607l-36.2-34.6h-1.1v34.6h-13.2V95.1h13.2v65.7h1.5l29.9-32.8h16.8L581 166.2l43.7 40.1z'
      className='st0'
    />
    <path
      d='M133.7 158v48.9h-19.4V158c-1.5-13.2-11-16.2-19.9-13.7-7.4 2.3-11.6 7.8-13.2 10.5v52H62v-77.3h17.4v-.2l.5 2.3 1.4 6.9c10.5-10.5 24.2-15 38.5-7.1 14.4 7.9 13.9 26.6 13.9 26.6z'
      style={{
        fill: '#21428a',
        stroke: '#21428a',
        strokeWidth: 0.12,
        strokeMiterlimit: 10,
      }}
    />
  </svg>
)
export default LogoNBC
